import { computed, Ref } from 'vue';

import {
  ClientReferenceNumberType,
  DATE_OR_TIME_TYPES,
  ReferenceNumberValueType,
  TIME_TYPES,
} from '@rygen/rygen-ui/model';

export interface UseReferenceNumberValueTypesResponse {
  isDateOrTimeType: Ref<boolean>;
  isMultiChoice: Ref<boolean>;
  isFreeformMultiChoice: Ref<boolean>;
  isTimeType: Ref<boolean>;
  isTimeTypeOnly: Ref<boolean>;
  isDropdown: Ref<boolean>;
}

export const useReferenceNumberValueTypes = (
  clientReferenceNumberType: Ref<ClientReferenceNumberType | undefined>,
): UseReferenceNumberValueTypesResponse => {
  const isDateOrTimeType = computed(() => {
    return (
      !!clientReferenceNumberType.value?.referenceNumberType?.valueType &&
      DATE_OR_TIME_TYPES.includes(
        clientReferenceNumberType.value.referenceNumberType.valueType,
      )
    );
  });

  const isMultiChoice = computed(() => {
    return (
      clientReferenceNumberType.value?.referenceNumberType?.valueType ===
      ReferenceNumberValueType.MULTI_CHOICE
    );
  });

  const isFreeformMultiChoice = computed(() => {
    return (
      isMultiChoice.value &&
      !!clientReferenceNumberType.value?.referenceNumberType?.allowFreeformValue
    );
  });

  const isTimeType = computed(() => {
    return (
      !!clientReferenceNumberType.value?.referenceNumberType?.valueType &&
      TIME_TYPES.includes(
        clientReferenceNumberType.value.referenceNumberType.valueType,
      )
    );
  });

  const isDropdown = computed(() => {
    return (
      clientReferenceNumberType.value?.referenceNumberType?.valueType ===
      ReferenceNumberValueType.DROPDOWN
    );
  });

  const isTimeTypeOnly = computed(
    () =>
      clientReferenceNumberType.value?.referenceNumberType?.valueType ===
      ReferenceNumberValueType.TIME,
  );

  return {
    isDateOrTimeType,
    isMultiChoice,
    isFreeformMultiChoice,
    isTimeType,
    isTimeTypeOnly,
    isDropdown,
  };
};
